export default __webpack_public_path__ + "static/media/wwr-img-b.e8912607.webp";